import React, { useEffect, useState } from "react";
import HomePage from "../homePage";
import * as ctf from "contentful";


const DeskTopHome = () => {
    const [news, setNews] = useState([]);
    const [projects, setProjects] = useState([]);
    const [homeData, setHomeData] = useState([]);
    const client = ctf.createClient({
        space: "fdtw7gymput4",
        accessToken: "-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E",
    });

    useEffect(() => {
        fetchData();
        fetchDataProject();
        fetchDataHome();
    }, []);
    console.log("Contentfull", news);
    console.log("Contentfull Projects", projects);

    const fetchData = async () => {
        try {
            const resp = await client.getEntries({ content_type: "news" });
            setNews(resp.items);
        } catch (error) {
            console.log(error);
        }
    };
    const fetchDataProject = async () => {
        try {
            const resp = await client.getEntries({ content_type: "projects" });
            setProjects(resp.items);
        } catch (error) {
            console.log(error);
        }
    };
    const fetchDataHome = async () => {
        try {
            const resp = await client.getEntries({ content_type: "homePage" });
            setHomeData(resp.items);
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <div>
            <HomePage news={news} projects={projects} home={homeData} />
        </div>
    )
}

export default DeskTopHome